import EmailSent from './EmailSent';

export default EmailSent;
